import React from 'react';
import {
  Chart,
  ChartContainer,
  ChartFill,
  ChartLineWrapper,
  ChartName,
  ChartRow,
  ChartTitle,
  ChartValue,
  Container,
  TeamContainer,
  TeamLogo,
  TeamName,
  TeamRank,
  TeamWrapper,
  Title,
  Versus
} from './styled';
import SportsTeamLogo from '../../../../../../components/teamLogo';

const HockeyTeamStat = ({ data }) => {
  const { home, away } = data;

  if (!data.home.teamData || !data.away.teamData) {
    return null;
  }

  return (
    <Container>
      <Title>팀 시즌 성적</Title>
      <TeamContainer>
        <TeamInfo data={home} />
        <Versus>
          <span>VS</span>
        </Versus>
        <TeamInfo data={away} />
      </TeamContainer>
      <ChartComp data={data} />
    </Container>
  );
};

const TeamInfo = ({ data }) => {
  return (
    <TeamWrapper>
      <TeamLogo>
        <SportsTeamLogo
          className="logo"
          imgSize={60}
          imgUrl={data.teamData.teamEmblemPath}
          isLazy={false}
          location="data"
        />
      </TeamLogo>
      <TeamName>{data.name}</TeamName>
      <TeamRank>
        {data.teamData.rank && `${data.teamData.rank}위 `}
        {data.teamData.winCount && `${data.teamData.winCount}승 `}
        {data.teamData.lossCount && `${data.teamData.lossCount}패 `}/ 연장
        {data.extraWinCount && ` ${data.extraWinCount}승 `}
        {data.extraDefeatCount && `${data.extraDefeatCount}패`}
      </TeamRank>
    </TeamWrapper>
  );
};

const ChartComp = ({ data }) => {
  const { home, away } = data;

  return (
    <ChartContainer>
      <ChartRowComp
        title={'승점'}
        homeValue={home.teamData.winPoint}
        awayValue={away.teamData.winPoint}
      />
      <ChartRowComp
        title={'득점'}
        homeValue={home.totalGetScore}
        awayValue={away.totalGetScore}
      />
      <ChartRowComp
        title={'실점'}
        homeValue={home.totalLoseScore}
        awayValue={away.totalLoseScore}
      />
    </ChartContainer>
  );
};
const ChartRowComp = ({ homeValue, awayValue, title }) => {
  const totalValue = parseInt(homeValue) + parseInt(awayValue);
  return (
    <ChartRow>
      <ChartTitle>
        <ChartValue>{homeValue}</ChartValue>
        <ChartName>{title}</ChartName>
        <ChartValue>{awayValue}</ChartValue>
      </ChartTitle>
      <ChartLineWrapper>
        <Chart>
          <ChartFill
            isWinner={homeValue > awayValue}
            style={{ width: `${(homeValue / totalValue) * 100}%` }}
          />
        </Chart>
        <Chart>
          <ChartFill
            isWinner={awayValue > homeValue}
            style={{ width: `${(awayValue / totalValue) * 100}%` }}
          />
        </Chart>
      </ChartLineWrapper>
    </ChartRow>
  );
};

export default HockeyTeamStat;
